import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ColorSchemeService } from '@fantaz/shared/services/color-scheme';
import { Observable, Subject } from 'rxjs';
@Component({
  selector: 'fz-tournament-feature-shell',
  templateUrl: './tournament-features-shell.component.html',
  styleUrls: ['./tournament-features-shell.component.css'],
})
export class TournamentFeatureShellComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  links = ['Cash Prize Tournament', 'Life Experience Prize Tournaments'];

  activeLink = '1';
  isLoggedIn$: Observable<boolean>;
  unsubscribe$: Subject<void> = new Subject<void>();
  openZendesk = false;
  ready = false;

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private readonly colorSchemeService: ColorSchemeService,
  ) {
    this.colorSchemeService.init();
  }

  ngAfterViewInit(): void {
    this.ready = true;
    const url = new URL(window.location.href);
    const reportIssue = url.searchParams.get('reportIssue');
    this.openZendesk = reportIssue === 'true';
  }

  ngOnInit() {
    this.titleService.setTitle('Fantaz Cash Prize Tournament');
    this.metaTagService.addTags([
      { name: 'keywords', content: 'Cash Prize Tournament' },
    ]);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get colorScheme() {
    return localStorage.getItem('scheme') as string;
  }
}
